import {isObject} from '@macmillanplatform/ui-core/utils';

import {AUTH_EXPIRY_MS, AUTH_STORAGE_KEY} from '../constants';
import type {AuthData} from '../types';

import {browserHistory} from '@/shared/utils';

const isAuthData = (value: unknown): value is AuthData => isObject(value);

const writeAuthData = (authData: AuthData) =>
  localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(authData));

export const readAuthData = (): AuthData | null => {
  const savedData = localStorage.getItem(AUTH_STORAGE_KEY);
  if (!savedData) return null;

  try {
    const parsed: unknown = JSON.parse(savedData);

    return isAuthData(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

export const updateAuthData = (patch: Partial<AuthData>) =>
  writeAuthData({...readAuthData(), ...patch});

export const saveCredentials = (link_account: string, zip_code: string) =>
  writeAuthData({
    values: {link_account, zip_code},
    expiry: Date.now() + AUTH_EXPIRY_MS,
  });

export const clearAuthData = () => localStorage.removeItem(AUTH_STORAGE_KEY);

export const clearAuthSession = () => {
  if (!localStorage.getItem(AUTH_STORAGE_KEY)) return;

  clearAuthData();
  browserHistory.deleteAllParameters();
};
